import CampusGradeList from '@/controllers/campus_grade/campus-grade-list';

export default {
  extends: CampusGradeList,

  methods: {
    excelImport() {
      this.$router.push({ name: 'campusGradeImport' });
    },
  },
};
